import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { Button } from 'reactstrap';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { TypedMemo } from '../common/types';
import { useSMLRouter } from '../../routing/sml/hooks';
import { SMLRoutes } from '../../routing/sml/SMLRoutes';
import { TeamAcceptCard } from './TeamAcceptCard';
import { TeamAcceptHeading } from './TeamAcceptHeading';
import styles from './TeamAcceptStateCard.module.scss';
import { withBrandWord } from '../music24/components/primitives/BrandWord';

interface TeamAcceptStateCardProps {
  /** `danger` for an invite that no longer works (q1), `neutral` for an incomplete link (q4). */
  tone: 'danger' | 'neutral';
  icon: IconDefinition;
  title: string;
  lead: string;
  note?: string;
}

/** Designs q1 and q4: an icon, a title, a line of help, and one "Go to Music24" button. No Join. */
const TeamAcceptStateCardComponent: React.FC<TeamAcceptStateCardProps> = ({ tone, icon, title, lead, note }) => {
  const intl = useIntl();
  const router = useSMLRouter();
  const goHome = useCallback(() => router.replace(SMLRoutes.home), [router]);

  return (
    <TeamAcceptCard>
      <div className={clsx('mb-3', styles.stateIcon, tone === 'neutral' && styles.stateIconNeutral)}>
        <FontAwesomeIcon icon={icon} />
      </div>
      <TeamAcceptHeading title={title} lead={lead} />
      {note !== undefined && <p className={`small mb-3 ${styles.note}`}>{note}</p>}
      <Button
        color={tone === 'danger' ? 'primary' : 'secondary'}
        outline={tone !== 'danger'}
        className="w-100"
        onClick={goHome}
      >
        {withBrandWord(intl.formatMessage({ id: 'app.sml.team.accept.goHome', defaultMessage: 'Go to MUSIC24' }))}
      </Button>
    </TeamAcceptCard>
  );
};

export const TeamAcceptStateCard = TypedMemo(TeamAcceptStateCardComponent);
